import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { get_PLUGIN_INSTALLED_LIST1ftwjhwye1pz5 as get_PLUGIN_INSTALLED_LIST } from './plugins/HttpClientPlugin.mjs';
import {
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
} from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { AttributesJsFn25rjfgcprgprf as AttributesJsFn } from '../../../../ktor-ktor-utils/io/ktor/util/Attributes.web.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import { PlatformUtils_getInstanceitqdjrwn2jrm as PlatformUtils_getInstance } from '../../../../ktor-ktor-utils/io/ktor/util/PlatformUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function installPlugin($this, plugin) {
  if ($this.h5h_1.x4(plugin.r3()))
    return Unit_instance;
  var tmp0 = $this.h5h_1;
  var tmp2 = plugin.r3();
  // Inline function 'kotlin.collections.set' call
  var value = (scope) => {
    var tmp = get_PLUGIN_INSTALLED_LIST();
    var attributes = scope.e5g_1.a4n(tmp, HttpClientConfig$installPlugin$lambda$lambda);
    var config = ensureNotNull(scope.h5g_1.i5h_1.z4(plugin.r3()));
    var pluginData = plugin.a5i(config);
    plugin.b5i(pluginData, scope);
    attributes.x4m(plugin.r3(), pluginData);
    return Unit_instance;
  };
  tmp0.c5(tmp2, value);
}
function HttpClientConfig$engineConfig$lambda(_this__u8e3s4) {
  return Unit_instance;
}
function HttpClientConfig$install$lambda(_this__u8e3s4) {
  return Unit_instance;
}
function HttpClientConfig$installPlugin$lambda$lambda() {
  return AttributesJsFn(true);
}
var HttpClientConfigClass;
function HttpClientConfig() {
  if (HttpClientConfigClass === VOID) {
    class $ {
      constructor() {
        var tmp = this;
        // Inline function 'kotlin.collections.mutableMapOf' call
        tmp.h5h_1 = LinkedHashMap().gc();
        var tmp_0 = this;
        // Inline function 'kotlin.collections.mutableMapOf' call
        tmp_0.i5h_1 = LinkedHashMap().gc();
        var tmp_1 = this;
        // Inline function 'kotlin.collections.mutableMapOf' call
        tmp_1.j5h_1 = LinkedHashMap().gc();
        var tmp_2 = this;
        tmp_2.k5h_1 = HttpClientConfig$engineConfig$lambda;
        this.l5h_1 = true;
        this.m5h_1 = true;
        this.n5h_1 = false;
        this.o5h_1 = PlatformUtils_getInstance().f4o_1;
      }
      c5i(plugin, configure) {
        var previousConfigBlock = this.i5h_1.z4(plugin.r3());
        var tmp0 = this.i5h_1;
        var tmp2 = plugin.r3();
        // Inline function 'kotlin.collections.set' call
        var value = (_this__u8e3s4) => {
          var tmp0_safe_receiver = previousConfigBlock;
          if (tmp0_safe_receiver == null)
            null;
          else
            tmp0_safe_receiver(_this__u8e3s4);
          configure(!(_this__u8e3s4 == null) ? _this__u8e3s4 : THROW_CCE());
          return Unit_instance;
        };
        tmp0.c5(tmp2, value);
        installPlugin(this, plugin);
      }
      p5h(plugin, configure, $super) {
        var tmp;
        if (configure === VOID) {
          tmp = HttpClientConfig$install$lambda;
        } else {
          tmp = configure;
        }
        configure = tmp;
        var tmp_0;
        if ($super === VOID) {
          this.c5i(plugin, configure);
          tmp_0 = Unit_instance;
        } else {
          tmp_0 = $super.c5i.call(this, plugin, configure);
        }
        return tmp_0;
      }
      q5h(key, block) {
        // Inline function 'kotlin.collections.set' call
        this.j5h_1.c5(key, block);
      }
      b5h(client) {
        // Inline function 'kotlin.collections.forEach' call
        var _iterator__ex2g4s = this.h5h_1.b5().u1();
        while (_iterator__ex2g4s.v1()) {
          var element = _iterator__ex2g4s.w1();
          // Inline function 'kotlin.apply' call
          element(client);
        }
        // Inline function 'kotlin.collections.forEach' call
        var _iterator__ex2g4s_0 = this.j5h_1.b5().u1();
        while (_iterator__ex2g4s_0.v1()) {
          var element_0 = _iterator__ex2g4s_0.w1();
          // Inline function 'kotlin.apply' call
          element_0(client);
        }
      }
      r5h(other) {
        this.l5h_1 = other.l5h_1;
        this.m5h_1 = other.m5h_1;
        this.n5h_1 = other.n5h_1;
        var tmp0 = this.h5h_1;
        // Inline function 'kotlin.collections.plusAssign' call
        var map = other.h5h_1;
        tmp0.e5(map);
        var tmp0_0 = this.i5h_1;
        // Inline function 'kotlin.collections.plusAssign' call
        var map_0 = other.i5h_1;
        tmp0_0.e5(map_0);
        var tmp0_1 = this.j5h_1;
        // Inline function 'kotlin.collections.plusAssign' call
        var map_1 = other.j5h_1;
        tmp0_1.e5(map_1);
      }
    }
    initMetadataForClass($, 'HttpClientConfig', HttpClientConfig);
    HttpClientConfigClass = $;
  }
  return HttpClientConfigClass;
}
//region block: exports
export {
  HttpClientConfig as HttpClientConfigo6p492ed655g,
};
//endregion

//# sourceMappingURL=HttpClientConfig.mjs.map
